import React from 'react'

function HomePage() {
  return <p style={{ color: 'red' }}>this is my home page !</p>
}
export default HomePage
